import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export const STUDIO_MODAL_PANEL =
  "flex h-[min(92vh,920px)] w-[min(96vw,1440px)] flex-col overflow-hidden rounded-lg border border-border bg-card text-card-foreground shadow-xl";

export function StudioModalFrame({
  children,
  labelledBy,
  zClass = "z-50",
  onBackdropClick,
}: {
  children: ReactNode;
  labelledBy?: string;
  zClass?: string;
  onBackdropClick?: () => void;
}) {
  return (
    <div
      className={cn("fixed inset-0 flex items-center justify-center bg-black/60 p-3", zClass)}
      onClick={onBackdropClick}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby={labelledBy}
        className={STUDIO_MODAL_PANEL}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}

export function StudioModalHeader({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn("shrink-0 border-b border-border px-5 py-4", className)}>{children}</div>;
}

export function StudioModalBody({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn("min-h-0 flex-1 overflow-auto", className)}>{children}</div>;
}

export function StudioModalFooter({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn("shrink-0 border-t border-border px-5 py-3", className)}>{children}</div>;
}
